<app-short-code-list (resultsLoaded)="resultsLoaded($event)" [listMode]="'needsaction'"></app-short-code-list>